import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';

export default {
  name: 'propertyApplications',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users],
  data: function () {
    return {
      Applications: [],
      ApplicationsCols: [],

      TotalRow: 0,
      Pageingoptions: { pageSize: 10, total: 0, page: 1 },
    }
  },
  props: {
    propertyId: {
      type: String,
      required: true
    }
  },
  created() {
    this.configColumns();
    this.getData();
  },
  methods: {
    configColumns() {
      this.ApplicationsCols.push({ dataField: 'applicationId', caption: this.$t('enquiriesPropertyApplications.applicationId') });
      this.ApplicationsCols.push({ dataField: 'applicationDate', caption: this.$t('enquiriesPropertyApplications.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.ApplicationsCols.push({ dataField: 'applicationType', caption: this.$t('enquiriesPropertyApplications.type') });
      this.ApplicationsCols.push({ dataField: 'status', caption: this.$t('enquiriesPropertyApplications.status') });
      this.ApplicationsCols.push({ dataField: 'comment', caption: this.$t('enquiriesPropertyApplications.comment') });
      this.ApplicationsCols.push({ dataField: 'hasDigitalSignatures', caption: this.$t('enquiriesPropertyApplications.hasDigitalSignatures') });
    },
    getData() {
      var parameters = {
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.Pageingoptions
      }

      axios.post('/Enquiries/GetPropertyApplications', parameters)
        .then(response => {
          if (response.status == 200) {
            this.Applications = response.data.items;

            this.TotalRow = response.data.itemsCount;
          }
        })
        .catch(e => {  return false; })
    },
    PageChange(pInfo) {
      this.Pageingoptions.page = pInfo.pageNumber;
      this.Pageingoptions.pageSize = pInfo.pageSize;
      this.getData();
    },

    applicationSelected(item) {
      if (item.data.sourceType == 1) {
        this.$oldAlertMsg(this.$t('enquiries.cantOpenOldApp'));
        return;
      }

      window.open(window.location.origin + `/application/${item.data.applicationId}`);
    },
  },
}
